<template>
  <div id="map">
    <baidu-map class="map" :center="center" ak="TdjjUm3DDvXztsh31KKjogByHtfBVfAw" mapType="BMAP_NORMAL_MAP" :scroll-wheel-zoom="true" :zoom="zoom" @load="lod()">
      <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP', 'BMAP_PERSPECTIVE_MAP', 'BMAP_SATELLITE_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :autoLocation="true" ></bm-geolocation>
      <div v-for="(position, index) in positions" :key="index">
        <bm-marker @click="goPro(position.id, position.city)" :position="{lng:position.longitude,lat:position.latitude}"  animation="BMAP_ANIMATION_BOUNCE" :icon="{url: require('../../assets/img/icon/indoor.png'), size: {width: bwidth, height: bheight}}"></bm-marker>
      </div>
      <div class="control">
        <div @click="addZoom(1)"><span>+</span></div>
        <div @click="addZoom(-1)"><span>-</span></div>
      </div>
    </baidu-map>
  </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import { BmMarker, BmGeolocation, BmMapType } from 'vue-baidu-map'
export default {
  name: 'MyMap',
  props: ['positions'],
  components: {
    BaiduMap,
    BmMapType,
    BmMarker,
    BmGeolocation
  },
  data () {
    return {
      zoom: 10,
      bwidth: 60,
      bheight: 60,
      center: '上海'
    }
  },
  methods: {
    lod () {
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth
      this.bwidth = oWidth * 60 / 1920
      this.bheight = oWidth * 60 / 1920
    },
    goPro (id, city) {
      window.localStorage.setItem('proId', id)
      this.$store.commit('setProjectName', id)
      this.$router.replace('/projectAreaDetail' + id)
      window.localStorage.setItem('proCity', city)
    },
    addZoom (index) {
      this.zoom += index
      if (this.zoom > 19) {
        this.zoom = 19
      }
      if (this.zoom < 3) {
        this.zoom = 3
      }
    }
  },
  watch: {
    zoom (value) {
      this.$nextTick(() => {
        console.log(value)
      })
    }
  },
  mounted () {
    if (window.localStorage.getItem('center')) {
      this.center = JSON.parse(window.localStorage.getItem('center'))
    }
  }
}
</script>

<style scoped>
#map{
  position:relative;
width: 100%;
height: 100%;
overflow: hidden;
margin:0;
font-family:"微软雅黑";
}
.map{
width: 100%;
height: 100%;
}
.control{
  display:flex;
  align-items:ceter;
position:absolute;
width:72px;
height:32px;
background:white;
z-index:99;
bottom:30px;
right:50px;
border: 1px solid rgb(217, 215, 213);
border-radius: 4px;
font-size:24px;
line-height:30px;
cursor:pointer;
color:rgba(0,0,0,0.6);
font-weight:600;
}
.control div{
  width:50%;
  height:100%;
}
.control div:last-child{
border-left:1px solid #eee;
}
</style>
